export type FeedbackKind='success'|'info'|'error'|'reward';
export type FeedbackEvent={id:string;kind:FeedbackKind;text:string;at:number;group?:string};
export type FeedbackMessage={kind:FeedbackKind;text:string;at:number;count:number;ids:readonly string[];group?:string};
const priority:Record<FeedbackKind,number>={error:0,reward:1,success:2,info:3};
/** Feed actual event IDs only. Reconnection snapshots are not events. */
export class FeedbackQueue{
 private readonly seen=new Set<string>();
 private queue:FeedbackMessage[]=[];
 get length():number{return this.queue.length;}
 push(event:FeedbackEvent):boolean{
  if(!event.id||!event.text||!Number.isFinite(event.at)||this.seen.has(event.id))return false;
  this.seen.add(event.id);const tail=this.queue.at(-1);
  if((event.kind==='success'||event.kind==='info')&&tail?.kind===event.kind&&tail.text===event.text&&tail.group===event.group&&event.at>=tail.at&&event.at-tail.at<=1000){this.queue[this.queue.length-1]={...tail,at:event.at,count:tail.count+1,ids:[...tail.ids,event.id]};}
  else this.queue.push({kind:event.kind,text:event.text,at:event.at,count:1,ids:[event.id],...(event.group===undefined?{}:{group:event.group})});
  return true;
 }
 next():FeedbackMessage|undefined{
  if(!this.queue.length)return;
  let selected=0;for(let i=1;i<this.queue.length;i++)if(priority[this.queue[i]!.kind]<priority[this.queue[selected]!.kind])selected=i;
  const entry=this.queue.splice(selected,1)[0]!;return{...entry,ids:[...entry.ids]};
 }
 /** Explicit account/character ownership change, never ordinary panel closure. */
 resetOwner():void{this.queue=[];this.seen.clear();}
}
